import { requiredRule } from './validation/rules'
import { JleagueApiClient } from './libs/client'
import { setErrorMessage } from './common'

export default class FlpLogin {
    constructor() {
        this.clubCode = '';
        this.loginButton = null;
        this.loginIdField = null;
        this.passwordField = null;
        this.errorMessage = null;
        this.isXhr = false;
        this.isDisabled = true;
        this.access_token = null;
        this.mkdb_id = null;
        this.client_id = null;

        this.data = {
            loginId: '',
            password: ''
        };
    }

    ready() {
        const self = this;

        this.watch();
        this.loginIdField.addEventListener('input', function(){
            self.data.loginId = this.value;
        });
        this.passwordField.addEventListener('input', function(){
            self.data.password = this.value;
        });
        this.loginButton.addEventListener('click', function(){
            self.onSubmit();
        });
    }

    watch() {
        const self = this;
        const data = this.data;

        Object.getOwnPropertyNames(data).forEach(function(prop){
            let _value = data[prop];
            Object.defineProperty(data, prop, {
                get() {
                    return _value;
                },
                set(value) {
                    _value = value;

                    // ID/Passが未入力のときログインボタンを disabled にする
                    self.isDisabled = !(requiredRule(self.data.loginId) && requiredRule(self.data.password));
                }
            });
        });

        // ログインボタンの表示を変更する
        let _isXhr = this.isXhr;
        Object.defineProperty(this, 'isXhr', {
            get() {
                return _isXhr;
            },
            set(value) {
                _isXhr = value;
                self.changeLoginButton();
            }
        });

        let _isDisabled = this.isDisabled;
        Object.defineProperty(this, 'isDisabled', {
            get() {
                return _isDisabled;
            },
            set(value) {
                _isDisabled = value;
                self.changeLoginButton();
            }
        });
    }

    changeLoginButton() {
        this.loginButton.innerText = this.isXhr? '通信中': 'ログイン';

        if (this.isDisabled) {
            this.loginButton.setAttribute('disabled', 'disabled');
        } else {
            this.loginButton.removeAttribute('disabled');
        }
    }

    onSubmit() {
        // ボタンのラベルを「確認」から「通信中」へ変更する
        this.isXhr = true;
        this.isDisabled = true;

        const self = this;
        const client = new JleagueApiClient();
        const data = {
            login_id: this.data.loginId,
            password: this.data.password,
            club_cd: this.clubCode,
            client_id: this.client_id
        }
        if (this.mkdb_id !== null && this.access_token) {
            data.mkdb_id = this.mkdb_id;
            data.access_token = this.access_token;

            client.postFlpRelation(data)
                .then(function(response){
                    location.href = response.data.redirect_uri;
                })
                .catch(function(error){
                    setErrorMessage(error, self);
                })
                .finally(function(){
                    self.isXhr = false;
                    self.isDisabled = false;
                });
        }else{
            // 外部認証APIを実行する
            client.postExternalLogin(data)
                .then(function(response){
                    location.href = response.data.redirect_uri;
                })
                .catch(function(error){
                    setErrorMessage(error, self);
                })
                .finally(function(){
                    self.isXhr = false;
                    self.isDisabled = false;
                });
        }
    }
}
